// extracted by mini-css-extract-plugin
export const heroWrapper = "hero-with-image-module--hero-wrapper--3sLtT";
export const heroImageWrapper = "hero-with-image-module--hero-image-wrapper--1ejJ0";
export const heroChildren = "hero-with-image-module--hero-children--3Dvbj";